<template>
  <b-modal
    :active.sync="showModal"
    aria-role="dialog"
    aria-modal
    trap-focus
    scroll="clip"
    @close="closeModal"
  >
    <CloudflareVideoPlayer
      :auto-play="true"
      :video-id="videoId"
    ></CloudflareVideoPlayer>
  </b-modal>
</template>

<script>
import CloudflareVideoPlayer from './CloudflareVideoPlayer'
export default {
  name: 'VideoModal',
  components: {
    CloudflareVideoPlayer
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: this.show
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>
